import { isUndefined } from 'lodash';
import { Env } from '/@/Env';
import AnalyticsService from '@/integrations/analytics/AnalyticsService';
import Logger from '/@/modules/core/app/helpers/Logger';

export class BaseEventTracking {
  /**
   * @abstract
   *
   * To be implemented by child event class
   * @var {string}
   */
  static eventName;

  /**
   * @param args
   */
  static dispatch(...args) {
    try {
      const model = new this(...args);
      BaseEventTracking.validate(model);
      AnalyticsService.track(model.getName(), model.getProperties());
    } catch (e) {
      Logger.error(e.message);
    }
  }

  static dispatchIf(condition, ...args) {
    if (!condition) {
      return;
    }

    this.dispatch(...args);
  }

  /**
   * @param args
   */
  static dispatchWithIdentifyTraits(...args) {
    try {
      const model = new this(...args);
      BaseEventTracking.validate(model);
      AnalyticsService.track(model.getName(), model.getProperties());
      AnalyticsService.identifyWithEventProperties(model.getIdentifyProperties());
    } catch (e) {
      Logger.error(e.message);
    }
  }

  /**
   * @returns {Object.<string, *>}
   */
  getProperties() {
    const props = { ...this };
    delete props.eventName;
    return props;
  }

  /**
   * @returns {Object.<string, *>}
   */
  getIdentifyProperties() {
    const props = this.getProperties();
    this.getIdentifyPropertiesToOmit().forEach((property) => {
      delete props[property];
    });

    return props;
  }

  /**
   * @returns {string}
   */
  getName() {
    return this.constructor.eventName;
  }

  /**
   * @returns {boolean}
   */
  areAllPropertiesRequired() {
    return true;
  }

  /**
   * @returns {*[]}
   */
  getIdentifyPropertiesToOmit() {
    return [];
  }

  /**
   * @private
   *
   * @param {BaseEventTracking} model
   */
  static validate(model) {
    if (isUndefined(model.getName())) {
      throw new Error('Missing event name');
    }

    if (Env.isLocal() && model.areAllPropertiesRequired()) {
      let error = false;
      Object.keys(model).forEach((key) => {
        if (isUndefined(model[key])) {
          error = true;
          Logger.log(`Property value for ${key} is not defined in ${model.constructor.name}`);
        }
      });
      if (error) {
        throw new Error(`Missing property value for class: ${model.constructor.name}`);
      }
    }
  }
}
